import React, { Component } from "react";
import { selectVertualMovies } from "../../redux/movies/movies.selector";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import Table from "../tableComponent/table";
import { searchMovie } from "../../redux/movies/movies.action";
import { selectLoadingStatus } from "../../redux/movies/movies.selector";
import WithSpinner from "../withSpinner";
import TableDownloadableButton from "./tableDownloadableBtn";

class DownloadableMoviesTable extends Component {
  columns = [
    { title: "Title", path: "title" },
    { title: "Genre", path: "genre" },
    { title: "Movie ID", path: "_id" },
    { title: "Video ID", path: "videoId" },
    { title: "Upload Date", path: "uploadDate" },
    {
      title: "Make Downloadable",
      buttons: (movie) => (
        <TableDownloadableButton movie={movie} label="Make Downloadable" />
      ),
      className: "tc-center",
    },
  ];

  render() {
    const { movies, searchMovie, isLoading } = this.props;
    return isLoading ? (
      <WithSpinner />
    ) : (
      <React.Fragment>
        <Table
          elements={movies}
          columns={this.columns}
          search={searchMovie}
          title="All Movies"
          show="search"
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  movies: selectVertualMovies,
  isLoading: selectLoadingStatus,
});

const mapDispatchToProps = (dispatch) => ({
  searchMovie: (searchWord) => dispatch(searchMovie(searchWord)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DownloadableMoviesTable);
